module.exports = __webpack_public_path__ + "static/media/Ivysaur_gaussian2.8d1281f9.png";